import request from '@/utils/request'
import qs from 'qs'

export const postLoginApi = (postData) => {
  return request({
    url: '/user/login',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(postData)
  })
}

// 获取当前登录用户的仪表盘展示id
export const queryDashboardModule = (postData) => {
  return request({
    url: '/user/queryDashboardModule',
    method: 'post',
    data: postData
  })
}
// 用户权限内容创建
export const addUserDataRight = (postData) => {
  return request({
    url: '/user/addUserDataRight',
    method: 'post',
    data: postData
  })
}
